import type { ReactNode } from 'react';

/** Label/value line used on review + payment summaries. */
export function SumRow({
  label,
  children,
  strong,
  big,
}: {
  label: ReactNode;
  children: ReactNode;
  strong?: boolean;
  big?: boolean;
}) {
  return (
    <div
      className="wb-row wb-between"
      style={{ padding: big ? '10px 0' : '6px 0', alignItems: 'baseline' }}
    >
      <span
        className={big ? 'wb-h3' : 'wb-sub'}
        style={strong && !big ? { color: 'var(--ink)', fontWeight: 600 } : undefined}
      >
        {label}
      </span>
      <span
        className={big ? 'wb-h3' : 'wb-body'}
        style={{ fontWeight: strong || big ? 680 : 500, textAlign: 'right' }}
      >
        {children}
      </span>
    </div>
  );
}
